import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ChannelState {
  activeChannelId: string | null; // null = "Geral" (todos os channels)
  setActiveChannel: (id: string | null) => void;
}

export const useActiveChannel = create<ChannelState>()(
  persist(
    (set) => ({
      activeChannelId: null,
      setActiveChannel: (id) => set({ activeChannelId: id }),
    }),
    { name: 'mynd-active-channel' }
  )
);
